/** @jsxImportSource @emotion/react */

import { TVisitor } from "apis/visitors/type";
import Header from "./header";
import Item from "./item";
import { changeVisitorStatus } from "apis/visitors/visitor";

export const VisitorTable = ({
    visitors,
    onChange,
    visitRecordId,
    isPlannedVisit = false,
}: {
    visitors: TVisitor[];
    onChange?: () => void;
    visitRecordId?: string;
    isPlannedVisit?: boolean;
}) => {
    return (
        <div>
            <Header />
            {visitors.map((item, index) => {
                return (
                    <Item
                        isPlannedVisit={isPlannedVisit}
                        visitor={item}
                        key={item.id}
                        onChangeState={async () => {
                            if (visitRecordId && item.id) {
                                const res = await changeVisitorStatus(visitRecordId, item.id, "CHECK_OUT");
                                if (res.success) {
                                    onChange?.();
                                }
                            }
                        }}
                        onHandleSend={async () => {
                            onChange?.();
                        }}
                    />
                );
            })}
        </div>
    );
};

export default VisitorTable;
